import type { EatalyBreadcrumbItem } from './index';

/**
 * On ancestor click, drop later crumbs immediately (e.g. PDP product segment) before the loader resolves.
 * PLP→PLP / refine toggles rely on `useEatalyBreadcrumbs` optimistic rebuild instead of this trim.
 */
export function trimBreadcrumbTrailOnAncestorClick(
    items: EatalyBreadcrumbItem[],
    clickedIndex: number
): EatalyBreadcrumbItem[] | null {
    if (clickedIndex < 0 || clickedIndex >= items.length - 1) {
        return null;
    }

    const trimmed = items.slice(0, clickedIndex + 1);
    const last = trimmed.at(-1);
    if (!last) {
        return trimmed;
    }

    return [...trimmed.slice(0, -1), { ...last, href: undefined }];
}
